module.exports = "https://cdn.thelire.com/ins/resource/right-icon.adf41c4b79899340813c85efe271924e.png";